module.exports = __webpack_public_path__ + "page-not-found.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-not-found.jpg
// module id = 711
// module chunks = 0